import instance from "../config";

// metodo para trae todo los bloques
const getBloques = async (params) => {
  try {
    const { data } = await instance.get("/api/bloque", { params });
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// Metodo crear un Bloque
const PostBloques = async (name) => {
  const { data } = await instance.post("/api/bloque", { name });
  return data;
};

export const getBloqueByID = async (id, params) => {
  try {
    const response = await instance.get(`/api/bloque/${id}`, { params });
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// Metodo editar Bloque
const EditarBloque = async (id, name) => {
  try {
    const response = await instance.put(`/api/bloque/${id}`, { name });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

//Editar fecha de vencimiento
const editarFechaV = async (id, data) => {
  try {
    const response = await instance.patch(`/api/ventaR/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo de eliminar el bloque
const EliminarBloque = async (id) => {
  try {
    const response = await instance.delete(`/api/bloque/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

// crear un puesto a su blouqe
const PostPuesto = async (bloqueId, numero) => {
  const response = await instance.post("/api/puesto", { bloqueId, numero });
  return response.data;
};

// Metodo de eliminar el puesto
const EliminarPuesto = async (id) => {
  try {
    const response = await instance.delete(`/api/puesto/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

// consultar un puesto
export const getPuestoByID = async (id) => {
  try {
    const response = await instance.get(`/api/puesto/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

// crear un producto
// crear un puesto a su blouqe
const PostProducto = async (
  idPuesto,
  idClase,
  idTipo,
  dimension,
  cantidad,
  precioCompra,
  precioVenta,
  precioAlquilerDia
) => {
  try {
    const response = await instance.post("/api/producto", {
      idPuesto,
      idClase,
      idTipo,
      dimension,
      cantidad,
      precioCompra,
      precioVenta,
      precioAlquilerDia,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo eliminar un producto
const EliminarProducto = async (id) => {
  try {
    const response = await instance.delete(`/api/producto/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

// Metodo para editar un producto
const EditarProducto = async (
  id,
  idClase,
  idTipo,
  dimension,
  cantidad,
  precioCompra,
  precioVenta,
  precioAlquilerDia
) => {
  try {
    const response = await instance.put(`/api/producto/${id}`, {
      idClase,
      idTipo,
      dimension,
      cantidad,
      precioCompra,
      precioVenta,
      precioAlquilerDia,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
};

// Metodo para buscar a  un cliente
const BuscarCliente = async (cedula) => {
  try {
    const response = await instance.get(`/api/persona/${cedula}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// crear un cliente 
const PostCliente = async (personaId) => {
  try {
    const response = await instance.post("/api/cliente", { personaId });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};


// Metodo para actualizar los productos si la factura es paga
const PostActualizarventa = async (dataProductos) => {
  try {
    const response = await instance.post("/api/productos", { dataProductos });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para taer todo las ventas rapidas del sistema
const getVentaRapidas = async (params) => {
  try {
    const response = await instance.get("/api/ventaR", { params });
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

//Metodo que elimina la venta
const deleteVentaRapidas = async (id) => {
  try {
    const response = await instance.delete(`/api/ventaR/${id}`);
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

//Obtener deltta de la venta rapida
const obtenerDetalleventaR = async (id) => {
  try {
    const response = await instance.get(`/api/ventaR/${id}`);
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

//Metodo para pagar una factura de las ventas rapidas
const obtenerAbonos = async (id, total_pagado) => {
  try {
    const response = await instance.patch(`/api/abono/ventaR/${id}`, {
      total_pagado,
    });
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

//Metodo para entregar productos pendientes
const entregarPendientes = async (id, id_ventaR, pendiente_entrega) => {
  try {
    const response = await instance.patch(`/api/ventaRD/${id}`, {
      id_ventaR,
      pendiente_entrega,
    });
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

//Metodo para registrar una venta
const PostventaRapida = async (data) => {
  try {
    const response = await instance.post(`/api/ventaR`, data);
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

const postventaRapidaDetalle = async (id_ventaR, detalles) => {
  try {
    const response = await instance.post(`/api/ventaRD`, {
      id_ventaR,
      detalles,
    });
    return {
      status: response.status,
      res: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status || 500,
      res: error.response?.data || { msg: "Error desconocido" },
    };
  }
};

// metodo para obtener todas las facturas abiertas de las ventas rapidas
const getFacturasAbiertasVentasR = async () => {
  try {
    const response = await instance.get("/api/vencidas/ventaR");
    return response.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

//--------------------------------------//
//------------ Actulizar factura  ------//
//--------------------------------------//
const putVentaRaipa = async (id, estado, subtotal, descuento, financiado, total) => {
  try {
    const response = await instance.put(`/api/ventaR/${id}`, { estado, subtotal, descuento, financiado, total });
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
}
//--------------------------------------//
//-------------  Abonos  ---------------//
//--------------------------------------//
const postAbonoVR = async (ventaRapidaId, monto, descripcion,id_user, fecha_abono, hora_abono) => {
  
  try {
    const response = await instance.post("/api/abonoventarapida", {
      ventaRapidaId,
      monto,
      descripcion,
      id_user,
      fecha_abono,
      hora_abono
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

const putAbonoVR = async (id, monto, descripcion, fecha_abono, hora_abono) => {
  try {
    const response = await instance.put(`/api/abonoventarapida/${id}`, {
      monto,
      descripcion,
      fecha_abono,
      hora_abono,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para eliminar un abono
const deleteAbonoVR = async (id) => {
  try {
    const response = await instance.delete(`/api/abonoventarapida/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

// Metodo para eliminar un abono
const cambiarClienteCotizacion = async (id, nuevoClienteId) => {
  try {
    const response = await instance.patch(`/api/cambioF/ventaR/${id}`, { nuevoClienteId });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};



// metodo para actualizar la factura padre en general 
const actualizarVentaR = async (id, data) => {

  try {
    const response = await instance.patch(`/api/actualizar/ventaR/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}


//Metodo para actualizar el detalle de una venta rapida
const actualizarVentaRD = async (id, data) => {
  try {
    const response = await instance.put(`/api/ventaRD/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

//Metodo para eliminar el detalle de una venta rapida
const deleteVentaRD = async (id) => {
  try {
    const response = await instance.delete(`/api/ventaRD/${id}`);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

export {
  getBloques,
  PostBloques,
  PostPuesto,
  EditarBloque,
  EliminarBloque,
  EliminarPuesto,
  PostProducto,
  EliminarProducto,
  EditarProducto,
  BuscarCliente,
  PostCliente,
  PostActualizarventa,
  getVentaRapidas,
  deleteVentaRapidas,
  obtenerDetalleventaR,
  obtenerAbonos,
  entregarPendientes,
  PostventaRapida,
  postventaRapidaDetalle,
  getFacturasAbiertasVentasR,
  editarFechaV,
  postAbonoVR,
  putAbonoVR,
  deleteAbonoVR,
  putVentaRaipa,
  cambiarClienteCotizacion,
  actualizarVentaR,
  actualizarVentaRD,
  deleteVentaRD,
};
